import { useScrollReveal } from '../../../../hooks/useScrollReveal';

const neighborhoods = [
  { name: 'Historic Downtown', desc: 'King Street, Meeting Street, Waterfront Park, Rainbow Row' },
  { name: 'Mount Pleasant', desc: 'Patriots Point, Shem Creek, Town Center' },
  { name: 'Daniel Island', desc: 'Corporate campuses, residential, waterfront' },
  { name: 'Isle of Palms', desc: 'Beach destinations, vacation rentals, resort access' },
  { name: 'James Island', desc: 'Residential neighborhoods, Folly Beach corridor' },
  { name: 'West Ashley', desc: 'Business districts, hospitals, shopping centers' },
];

export default function CharlestonLocalService() {
  const ref = useScrollReveal<HTMLDivElement>();

  return (
    <section className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={ref} className="section-reveal">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
            {/* Text */}
            <div>
              <span className="text-gold text-xs tracking-widest uppercase font-semibold">Your Local Charleston Limo Service</span>
              <h2 className="font-display text-4xl md:text-5xl font-bold text-neutral-900 mt-3 mb-6 leading-tight">
                Complete Coverage<br />
                <span className="text-gold">Across Charleston, SC</span>
              </h2>
              <p className="text-neutral-600 leading-relaxed text-sm mb-4">
                Tec&apos;s Limo Service provides full-coverage luxury transportation throughout the greater Charleston metro area. From the historic downtown peninsula to the barrier islands and suburban communities, we serve every corner of the Lowcountry.
              </p>
              <p className="text-neutral-500 leading-relaxed text-sm mb-8">
                Our drivers have deep knowledge of Charleston&apos;s traffic patterns, neighborhoods, optimal routes, and local landmarks — ensuring the fastest, smoothest rides no matter your destination.
              </p>

              {/* Neighborhood grid */}
              <div className="grid grid-cols-2 gap-3">
                {neighborhoods.map((n) => (
                  <div key={n.name} className="group p-4 border border-neutral-100 hover:border-gold/30 transition-colors">
                    <div className="flex items-center gap-2 mb-1">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-2-fill text-gold text-xs"></i>
                      </div>
                      <span className="font-semibold text-neutral-900 text-xs group-hover:text-gold transition-colors">{n.name}</span>
                    </div>
                    <p className="text-neutral-400 text-xs pl-6">{n.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Image */}
            <div className="relative">
              <div className="w-full h-[460px] overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/8f2dd20848adc77e031dfa8ec8e92354.jpg"
                  alt="Limo service in Charleston SC local coverage"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-28 h-28 border-2 border-gold/30 pointer-events-none"></div>
              <div className="absolute bottom-8 left-8 bg-neutral-950/95 border border-gold/25 px-5 py-3">
                <div className="text-gold font-display text-2xl font-bold">20+</div>
                <div className="text-white/55 text-xs tracking-widest uppercase mt-0.5">Cities Covered</div>
              </div>
            </div>
          </div>

          {/* Airport access callout */}
          <div className="bg-neutral-950 p-8 border border-gold/15">
            <div className="grid sm:grid-cols-3 gap-8 items-center">
              <div className="sm:col-span-2">
                <h3 className="font-display text-xl font-bold text-white mb-2">
                  Charleston Airport Access — All 3 Locations
                </h3>
                <p className="text-white/50 text-sm leading-relaxed">
                  Direct, on-time transfers to <strong className="text-white/70">Charleston International Airport (CHS)</strong>, <strong className="text-white/70">Charleston Executive Airport</strong>, and <strong className="text-white/70">Mt. Pleasant Regional Airport</strong> — with real-time flight tracking from anywhere in Charleston, SC.
                </p>
              </div>
              <div className="flex flex-col gap-3">
                <a href="#contact" className="block text-center bg-gold hover:bg-gold-light transition-colors text-black font-bold px-6 py-3 text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer">
                  Book Airport Ride
                </a>
                <a href="tel:+18436422440" className="block text-center border border-gold/35 hover:border-gold text-gold hover:bg-gold/10 transition-all px-6 py-3 text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer font-semibold">
                  (843) 642-2440
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
